var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var OfflineError = /** @class */ (function (_super) {
    __extends(OfflineError, _super);
    function OfflineError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OfflineError;
}(Error));
export { OfflineError };
var ServerError = /** @class */ (function (_super) {
    __extends(ServerError, _super);
    function ServerError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ServerError;
}(Error));
export { ServerError };
var Ajax = /** @class */ (function () {
    function Ajax() {
    }
    Ajax.send = function (method, url, data) {
        if (data === void 0) { data = {}; }
        var request = new XMLHttpRequest();
        return new Promise(function (resolve, reject) {
            request.onreadystatechange = function () {
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        resolve(request.responseText);
                    }
                    else {
                        reject(new ServerError("Unexpected status: ".concat(request.statusText, " (expected: 200)")));
                    }
                }
            };
            request.open(method, url);
            request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            request.timeout = 10000;
            if (method == 'post') {
                request.send(JSON.stringify(data));
            }
            else {
                request.send();
            }
        });
    };
    Ajax.get = function (url) {
        return Ajax.send('get', url);
    };
    Ajax.post = function (url, data) {
        return Ajax.send('post', url, data);
    };
    Ajax.json = function (url, data, method) {
        if (data === void 0) { data = {}; }
        if (method === void 0) { method = 'post'; }
        return Ajax.send(method, url, data).then(function (data) {
            return JSON.parse(data);
        });
    };
    return Ajax;
}());
export default Ajax;
